import React from 'react';
import PropTypes from 'prop-types';
import Link from '../../Link';

import { BodyText } from '../../StyledComponents';

import './SiteLink.module.scss';

class SiteLink extends React.PureComponent {
  render() {
    const { text, url, isMobile, hoverColor, color } = this.props;

    return (
      <Link styleName="site-link" href={url} color={color} hoverColor={hoverColor}>
        <BodyText type="bodySecondary" isMobile={isMobile}>
          {text}
        </BodyText>
      </Link>
    );
  }
}

SiteLink.propTypes = {
  text: PropTypes.string,
  url: PropTypes.string,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default SiteLink;
